// extracted by mini-css-extract-plugin
export var callOutListItem = "ArticleCallOutIconListItem-module--callOutListItem--1FyRV";
export var imageIconWrapper = "ArticleCallOutIconListItem-module--imageIconWrapper--1VntX";
export var imageIcon = "ArticleCallOutIconListItem-module--imageIcon--2xYiD";
export var iconCircle = "ArticleCallOutIconListItem-module--iconCircle--1D1ws";
export var icon = "ArticleCallOutIconListItem-module--icon--s1l0m";
export var content = "ArticleCallOutIconListItem-module--content--ZVm6l";
export var title = "ArticleCallOutIconListItem-module--title--ogxS-";
export var text = "ArticleCallOutIconListItem-module--text--19gY-";